// extracted by mini-css-extract-plugin
export var toolTipContainer = "bn_dT";
export var toolTipLabel = "bn_dV";